<template>
  <div id="app">
    <div v-if="$store.state.hasLogin || (notUserInfoPageWatch && $route.path != '/login')">
      <!-- <router-view></router-view> -->
      <keep-alive>
        <router-view />
      </keep-alive>
      <!-- <router-view v-if="!$route.meta.keepAlive"/> -->
    </div>

    <div v-if="!notUserInfoPageWatch">
      <valid-user></valid-user>
    </div>
    <div v-if="!$store.state.hasLogin && $route.path == '/login'">
      <login></login>
    </div>
  </div>
</template>
<script>
import validUser from '@/components/ValidUser.vue'
import Login from '@/pages/login/index.vue'
export default {
  name: 'App',
  components: {
    validUser,
    Login
  },
  data() {
    return {
      notUserInfoPage: ['/login','/vendor-apply/declaration-Info/apply']
    }
  },
  // computed: {
  //   notUserInfoPageComputed() {
  //     return this.notUserInfoPage.includes(location.pathname)
  //   }
  // },
  created() {
    console.log('location.pathname: ',location.pathname)
  },
  watch: {
    '$route.path': {
      handler() {
        this.notUserInfoPageWatch = this.notUserInfoPage.includes(location.pathname)
      },
      deep: true,
      immediate: true,
    }
  }
}
</script>
<style lang="less" rel="stylesheet/less">
// @import './assets/main.less';
.content {
  height: 500px;
}

#app {
  .header {
    position: relative;

    .sollapse-bar {
      position: absolute;
      top: 0;
      left: 0;
      height: 48px;
      width: 46px;
      box-sizing: border-box;
      padding: 0;
      margin-top: 0;
      margin-bottom: 15px;
      display: inline-block;

      .sollapse-icon {
        color: #fff;
        width: 46px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        cursor: pointer;
        background-color: #456cf3;
      }

      .sollapse-icon:hover {
        background-color: #456cf3;
      }
    }

    .log .el-select {
      width: 100px;
      margin-right: 20px;

      .el-input__inner {
        color: #999;
        background: transparent;
        border: 1px solid #999;
      }
    }

    .title {
      margin-right: 40px;
      cursor: pointer;
    }
    .logout {
      margin-left: 5px;
    }
    .update-psw {
      margin: 0 5px !important;
    }
  }

  .el-button--text {
    padding-top: 0;
    padding-bottom: 0;
  }
}
body .el-table th.gutter {
  display: table-cell !important;
}
</style>
